import React from "react"

const ShareIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 22 22">
    <g fill="none" fillRule="evenodd">
      <g transform="translate(12.611 12.111) rotate(-30) translate(-9.5 -9.5)" strokeWidth="1.2782">
        <g transform="translate(8.6627 12.178) rotate(60) translate(-5.5 -3.5)">
          <ellipse cx="7.2795" cy="3.35" rx="2.6404" ry="2.7109" stroke="#999" />
          <path d="m0.47341 3.3851h3.7873" stroke="#979797" strokeLinecap="square" />
        </g>
        <g transform="translate(9.6288 4.0025) translate(-9 -4)">
          <circle cx="14.35" cy="4.35" r="2.7109" stroke="#999" />
          <path d="m7.4734 4.3851h3.7873" stroke="#979797" strokeLinecap="square" />
          <circle transform="translate(3.7212 4.3475) translate(-3.7212 -4.3475)" cx="3.7212" cy="4.3475" r="2.7109" stroke="#999" />
        </g>
      </g>
    </g>
  </svg>
)

export default ShareIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/ShareIcon.jsx